/**
 * B_Dom.js
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/child/dom/B_Dom.js
 * @목적 : Base - Dom 객체
 * @설명 : 객체를 Dom으로 만들고 싶을 때 상속받는 객체
 * @진행 : 개발종료
 * @주의 : 'visible = false' (초기화 흔적 때문에)
 * @이슈 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 : 없음
 */

import B_Define from 'canvas/base/dev/util/B_Define';
import B_Util from 'canvas/base/dev/util/B_Util';

const B_Dom = (function(superclass){

	const $ = {
		_dom : null,
		_domInnerId : null
	};

	class B_Dom extends superclass {

		constructor(inputJson) {
			super(inputJson);
			// /*[T]*/ console.log('B_DOM call');

			// [E] dom-id & z-index & padding
			if(typeof inputJson.dom === 'undefined') { B_Util.print(B_Define.MESSAGE['NO_CHILD_DOM']); return; }
			if(typeof inputJson.z === 'undefined') inputJson.z = 1;
			if(typeof inputJson.p === 'undefined') inputJson.p = 0;

			// [S] DOM 추가하기
			// [*] 'visible = false' (초기화 흔적 때문에)
			this._dom = B_Util.appendCanvasDom( this.CODMOS.CANVAS_WRAPPER, inputJson.dom, this.type, inputJson.w, inputJson.h, inputJson.z, inputJson.p );
			if(typeof inputJson.visible === 'boolean') this._visible = inputJson.visible; else this._visible = false;

			// [S] strResType, object
			this._strResType = B_Define.ARR_RES_TYPE[5];
			this._object = new createjs.DOMElement(inputJson.dom);
			this._container.addChild(this._object);

			if(typeof inputJson.innerHTML !== 'undefined') this.appendHtml(inputJson.innerHTML);
		}

		// [V] protected

		// [*] DOM :: visible => visibility 연결되어있음

		get _z() { if(this._dom) return this._dom.style['z-index']; }
		set _z(z) { if(this._dom) this._dom.style['z-index'] = z; }

		get _p() { if(this._dom) return this._dom.style['padding']; }
		set _p(p) { if(this._dom) this._dom.style['padding'] = p + "px"; }

		get _w() { if(this._dom) return this._dom.style['width'] ? this._dom.style['width'] : this._dom.scrollWidth; }
		set _w(w) { if(this._dom) this._dom.style['width'] = w + "px"; }

		get _h() { if(this._dom) return this._dom.style['height'] ? this._dom.style['height'] : this._dom.scrollHeight; }
		set _h(h) { if(this._dom) this._dom.style['height'] = h + "px"; }

		// [F] protected

		// @OVERRIDING
		_setArea(w, h) {
			if(super._checkArea(w,h)) {
				// super._checkArea 속에서 자동 수정
			}
		}

		// @OVERRIDING
		_setPoint(px, py) {
			if(super._checkReg(px, py)) {
				this._object.regX = this._w * this._pointX / 100;
				this._object.regY = this._h * this._pointY / 100;
			}
		}

		/**
		 * [ Function :: appendHtml ]
		 *
		 * @DES :: 인풋 HTMl 넣기
		 * @IP1 :: html {str}
		 * @O.P :: null
		 * @S.E :: this._dom 이 아닌 '첫번째 자식 Dom'에 넣는다.
		 */
		appendHtml (html) {
			// this._dom.children[0].innerHTML = html;
			this._dom.innerHTML = html;
		}

	}
	return B_Dom;
});

export default B_Dom;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/dom/B_Dom.js